export default __webpack_public_path__ + "static/media/0000..0000.9a4dea34.png";